import get from 'lodash-es/get';

export default function getStoreData(store, dataPath, subPath, def) {
    let path = dataPath || 'wizard.stepData';

    if (subPath) {
        path = `${path}.${subPath}`;
    }

    return get(store.state, path.replace(/\.{2,}/, '.').replace(/^\./, '').replace(/\.$/, ''), def);
}
